import React from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/png/logo_xerius.png"
import illustration1 from "components/../assets/svg/group59Copy.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import Fade from "@material-ui/core/Fade";
import {useHistory} from "react-router-dom";
import { BASE_URL } from '../../../env';
import { AppDataContext } from '../../../contexts/app-data';



const NotifOverlay = () => {
  const [hideOverlay, setHideOverlay] = React.useState(false)
  
  React.useEffect(() => {
    setTimeout(function () {
      setHideOverlay(true)
    }, 1200)
    if (window.PageBus) {
      window.PageBus.publish("analyticsServices", {
        pageID: "onboarding",
        stepSeq: "3",
        stepName: "pro info:popup data sent ",
        eventAction: "flowEnd",
        flowType: "sales",
        flowName: "onboarding",
        productName: "onboarding",
        trackMethod: "flow"
      });
    }

  }, [])

  return (
 <>
    <div className={hideOverlay ? "nitification-overlay off" : "nitification-overlay" }>
      <div className="wrapper">
    <BaseParagraph  illustration={illustration1} >
          <p>{t('pro_infos.pro_info_popup_data_sent.text')}</p>
     </BaseParagraph>
      </div>

    </div>

  </>
  )
}
 

const TextBody = () =>(
    <>
    <div className={'xerius-legal'}>
      <h3 className={'xerius_title'}>{t('pro_infos.pro_info_xerius.xerius_title')}</h3>
      <div className={'xerius_sub_title'}>{t('pro_infos.pro_info_xerius.xerius_sub_title')}</div>
      <div className={'xerius_price'}>{t('pro_infos.pro_info_xerius.xerius_price')}</div>
    </div>


    <h5> {t('pro_infos.pro_info_xerius.title')}</h5>
    <p>{t('pro_infos.pro_info_xerius.text1')}</p>
    <ul>
        <li>{t('pro_infos.pro_info_xerius.list.0')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.4')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.1')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.2')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.3')}</li>
    </ul>
        <h5> {t('pro_infos.pro_info_xerius.title2')}</h5>
    <p>{t('pro_infos.pro_info_xerius.text2')}</p>
    <p>{t('pro_infos.pro_info_xerius.text3')}</p>

    </>
)

const PreConfirmation = () => {
  const lang = localStorage.getItem('language')
  const history = useHistory();
    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`

  const [isLoading, setIsLoading] = React.useState(true)
  const [endLoading, setEndLoading] = React.useState(false)
  const [dataIsSent, setDataIsSent] = React.useState(false)

  const fetch_init_options = {
    method: 'POST',
    credentials: "include",
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',            
      }
  }

  React.useEffect(() => {
    const timeout= 900
  setTimeout(() => {
    setIsLoading(false)
  }, timeout);
    setEndLoading(true)
    
    if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "3",
stepName: "pro info:xerius",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }

        return function cleanup() {
            setEndLoading(false)
        };
  }, [])

  
  const actionWithXerius = () => {
      if (window.PageBus) {
        window.PageBus.publish("analyticsServices", {
          eventType: "button click",
          eventName: "continue with xerius",
          trackMethod: "trackAction"
          } );
        }
    history.push(`/${lang.toLowerCase()}/xerius-consent`);
  }

  const actionWithOutXerius = () => {
    if (window.PageBus) {
        window.PageBus.publish("analyticsServices", {
          eventType: "button click",
          eventName: "cancel xerius",
          trackMethod: "trackAction"
        });
      }
      setIsLoading(true)
      fetch(`${base_URL}/activation/ACTDS2`, fetch_init_options).catch( error => {
            console.log("error : "+ error)
      }).then(res => {
        return res.json()
      }).then(res => {

        setIsLoading(false)
        setDataIsSent(true)
         setTimeout(function () {
     history.push(`/${lang.toLowerCase()}/confirmation?xerius=no`);
    }, 1400)
      
    })
  }

    const { state, dispatch } = React.useContext(AppDataContext)

    return (
      <div className={"pre-confirmation"}>
        {dataIsSent && <NotifOverlay />}
        {/* <StepsWrapper stepGroupTitle={t('general.register_your_enterprise')} title={t('general.open_pro_account')}> */}
        <StepsWrapper stepGroupTitle={t('general.register_your_enterprise')} >
          <StepsLoader loading={isLoading}>
            <Fade in={endLoading} timeout={{ enter: 300, exit: 1200 }} >
              <div>
            <BaseParagraph illustration={illustration} />
              <BaseParagraph   >
                <TextBody />
              </BaseParagraph>

              <div className={"footer-action"} style={{bottom: state.footer_height}}>
                <BaseButton caption={t('pro_infos.pro_info_xerius.cat1')} nokb outline={true} darkBlue={true} action={actionWithOutXerius} />
                <BaseButton caption={t('pro_infos.pro_info_xerius.cat2')} action={actionWithXerius} />
              </div>
              </div>
          
          </Fade>


          </StepsLoader>
            </StepsWrapper>
        </div>
    )
}

PreConfirmation.propTypes = {
    name: PropTypes.string
}

PreConfirmation.defaultProps = {
    name: "Step02"
}


export default PreConfirmation